export type { DynamicFaviconProps } from './DynamicFavicon';
export { default } from './DynamicFavicon';
